var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tx_row"
  }, [_c('div', {
    staticClass: "info_col id_col"
  }, [_c('router-link', {
    staticClass: "id monospace",
    attrs: {
      "to": "/tx/".concat(_vm.transaction.id)
    }
  }, [_vm._v(_vm._s(_vm.transaction.id) + "...")]), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("fromNow")(_vm.transaction.timestamp)))]), _c('p', {
    staticClass: "type"
  }, [_vm.type !== '' ? _c('span', {
    staticClass: "tx_type_label"
  }, [_vm._v(_vm._s(_vm.type))]) : _vm._e()])], 1), _c('div', {
    staticClass: "avatar",
    style: {
      backgroundColor: _vm.chainDarkColor
    }
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.chainCode) + " ")])]), _c('div', {
    staticClass: "info_col utxo_list"
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('span', {
    staticClass: "label"
  }) : _vm._l(_vm.inputs, function (input, i) {
    return _c('InputUTXO', {
      key: i,
      attrs: {
        "input": input
      }
    });
  })], 2), _c('div', {
    staticClass: "info_col utxo_list"
  }, [_vm.isGenesisVertex ? [_c('v-btn', {
    staticClass: "ava_btn",
    attrs: {
      "text": true
    },
    on: {
      "click": _vm.goToTx
    }
  }, [_vm._v(" Explore Genesis Vertex ")])] : _vm._l(_vm.outputs, function (output, i) {
    return _c('OutputUTXO', {
      key: i,
      attrs: {
        "output": output
      }
    });
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }